import { render, staticRenderFns } from "./centrostrabajo.vue?vue&type=template&id=f0f8edd2"
import script from "./centrostrabajo.vue?vue&type=script&lang=js"
export * from "./centrostrabajo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports